import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  readonly label: ReactNode;
  readonly error?: string;
  readonly description?: string;
}

/**
 * Controlled or uncontrolled checkbox with required label. Mirrors HTHD's
 * customer-app `Checkbox.tsx` (label-required, label clickable).
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = '', label, error, description, id, ...props }, ref) => {
    const inputId = id ?? props.name;

    return (
      <div className={`ferro-checkbox${error ? ' ferro-checkbox--invalid' : ''}`}>
        <label htmlFor={inputId} className="ferro-checkbox__row">
          <input
            ref={ref}
            id={inputId}
            type="checkbox"
            className={`ferro-checkbox__input${className ? ` ${className}` : ''}`}
            {...props}
          />
          <span className="ferro-checkbox__label">
            <span className="ferro-checkbox__label-text">{label}</span>
            {description ? (
              <span className="ferro-checkbox__description">{description}</span>
            ) : null}
          </span>
        </label>
        {error ? <p className="ferro-form__error">{error}</p> : null}
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';
